




































import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class extends Vue {
  menu = false;

  @Prop()
  label!: string;

  @Prop()
  value!: string;

  @Prop({ default: '' })
  defaultValue!: string;

  @Prop({ default: false })
  disabled!: boolean;

  get time() {
    return this.value || this.defaultValue;
  }

  set time(value: string) {
    this.$emit('input', value);
  }

  created() {
    if (this.defaultValue) this.$emit('input', this.defaultValue);
  }
}
